import React, { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { useAdminOrganizationQuery } from '../../api/admin';
import { AppCard, AppCardTitle, AppPageHeader } from '../../components';
import { CreateTeamDialog, OrganizationMembersTable, TeamsTable } from '../../components/Admin';

export default function OrganizationDetailPage() {
	const { organization_id } = useParams<{ organization_id: string }>();
	const navigate = useNavigate();
	const location = useLocation();
	const organizationId = parseInt(organization_id!, 10);
	const [createTeamOpen, setCreateTeamOpen] = useState(false);

	const { organizationName: stateOrganizationName } =
		(location.state as { organizationName?: string }) ?? {};
	const { data: organization } = useAdminOrganizationQuery(organizationId);

	const organizationName = organization?.name ?? stateOrganizationName ?? `Organization #${organizationId}`;

	return (
		<>
			<AppPageHeader>
				<Stack direction="row" alignItems="center" spacing={2} mb={1}>
					<Button
						size="small"
						startIcon={<ArrowBackIcon />}
						onClick={() => navigate('/admin/users?tab=organizations')}
					>
						All Organizations
					</Button>
				</Stack>
				<Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%' }}>
					<Box>
						<Typography variant="h5">{organizationName}</Typography>
						{organization && (
							<Typography variant="body2" color="text.secondary">
								{organization.team_count} team{organization.team_count !== 1 ? 's' : ''} ·{' '}
								{organization.user_count} user{organization.user_count !== 1 ? 's' : ''}
							</Typography>
						)}
						{organization?.description && (
							<Typography variant="body2" color="text.secondary">
								{organization.description}
							</Typography>
						)}
					</Box>
					<Button variant="contained" startIcon={<GroupAddIcon />} onClick={() => setCreateTeamOpen(true)}>
						New Team
					</Button>
				</Box>
			</AppPageHeader>
			<AppCard>
				<AppCardTitle variant="h6">Teams</AppCardTitle>
				<TeamsTable organizationId={organizationId} height={300} />
			</AppCard>
			<AppCard>
				<AppCardTitle variant="h6">Users</AppCardTitle>
				<OrganizationMembersTable organizationId={organizationId} height={400} />
			</AppCard>
			<CreateTeamDialog
				open={createTeamOpen}
				onClose={() => setCreateTeamOpen(false)}
				defaultOrganizationId={organizationId}
			/>
		</>
	);
}
